// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__1WuJA","back":"layout_back__2_QFr","search":"layout_search__2w3AN","logo":"layout_logo__2iRX9"};